<template>
    <div class="mc-search-bar">
        <div class="mc-search-bar-input">
            <el-input :placeholder="searchLabel" v-model="value" @keyup.native.enter="searchSubmit"></el-input>
        </div>
        <el-button class="mc-search-bar-btn" type="primary" icon="el-icon-search" @click="searchSubmit" size="mini"></el-button>
        <el-button class="mc-search-bar-btn" type="danger" icon="el-icon-close" @click="$_reset" size="mini" v-if="value"></el-button>
        <span>{{'里面的值' +value}}</span>
    </div>
</template>

<script>
    export default {
        name: "test-search-bar",
        props: {
            defaultInput: {
                type: String,
                default: ''
            },
            searchLabel: {
                type: String,
                default: "请输入..."
            },
            searchSubmit: {
                type: Function,
                default: () => {}
            }
        },
        data() {
            return {
                value: ""
            };
        },
        created(){
            if(this.defaultInput){
                this.value = this.defaultInput;
            }
        },
        methods: {
            $_reset() {
                this.value = "";
                //   this.$store.state.searchBar.value = "";
                this.searchSubmit();
            },
        },
        // watch: {
        //     value: function () {
        //         // console.log('子组件值改变')
        //         // this.value = value;
        //     }
        // },
        destroyed() {
            // this.value = "";
            // this.$store.state.searchBar.value = "";
        }
    };
</script>

<style lang="less" scoped>
    .mc-search-bar {
        width: 100%;
        height: 100%;
        display: flex;

        .mc-search-bar-input {
            width: 300px;
            margin-right: 10px;
        }

        .mc-search-bar-btn {
            height: 40px;
        }
    }
</style>